import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ConfigProvider, Layout } from "antd";
import Dashboard from "./pages/Dashboard";
import CaseView from "./pages/CaseView";
import NewCase from "./pages/NewCase";
import AIAssistant from "./pages/AIAssistant";
import ReferenceCatalog from "./pages/ReferenceCatalog";
import ArchivoTexto from "./pages/ArchivoTexto";
import DocumentsPage from "./pages/Documents";
import DeadlinesPage from "./pages/Deadlines";
import PlanillaPage from "./pages/Planilla";
import Sidebar from "./components/Sidebar";
import "./App.css";

const { Content } = Layout;

function AppLayout() {
  const location = useLocation();
  const isArchivo = location.pathname === "/" || location.pathname === "/archivo";

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <Content
          style={
            isArchivo
              ? { margin: 0, padding: 0, background: "transparent", overflow: "auto" }
              : { margin: "24px 16px", padding: 24, background: "#fff" }
          }
        >
          <Routes>
            <Route path="/" element={<ArchivoTexto />} />
            <Route path="/archivo" element={<ArchivoTexto />} />
            <Route path="/catalogo" element={<ReferenceCatalog />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/case/:caseId" element={<CaseView />} />
            <Route path="/new-case" element={<NewCase />} />
            <Route path="/ai-assistant" element={<AIAssistant />} />
            <Route path="/documents" element={<DocumentsPage />} />
            <Route path="/deadlines" element={<DeadlinesPage />} />
            <Route path="/planilla" element={<PlanillaPage />} />
            <Route path="*" element={<ArchivoTexto />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#2f6b57",
          borderRadius: 4,
          fontFamily: '"Outfit", "Segoe UI", sans-serif',
        },
      }}
    >
      <Router>
        <AppLayout />
      </Router>
    </ConfigProvider>
  );
}

export default App;
